import * as React from "react";
import * as ReactDOM from "react-dom";

import LandingPageMain from "./components/Landing/landingpagemain.component";
declare var document;
class Container extends React.Component {
  render() {
    return <LandingPageMain />;
  }
}

ReactDOM.render(<Container />, document.getElementById("containerHome"));



// WEBPACK FOOTER //
// ./assets/react/landingpagemain.tsx